var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#155C8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7074 19.293C22.5199 19.1055 22.2656 19.0002 22.0004 19.0002C21.7352 19.0002 21.4809 19.1055 21.2934 19.293L20.0004 20.586V9C20.0004 8.73478 19.895 8.48043 19.7075 8.29289C19.52 8.10536 19.2656 8 19.0004 8C18.7352 8 18.4808 8.10536 18.2933 8.29289C18.1058 8.48043 18.0004 8.73478 18.0004 9V20.586L16.7074 19.293C16.5188 19.1108 16.2662 19.01 16.004 19.0123C15.7418 19.0146 15.491 19.1198 15.3056 19.3052C15.1202 19.4906 15.015 19.7414 15.0127 20.0036C15.0105 20.2658 15.1112 20.5184 15.2934 20.707L18.2934 23.707C18.4809 23.8945 18.7352 23.9998 19.0004 23.9998C19.2656 23.9998 19.5199 23.8945 19.7074 23.707L22.7074 20.707C22.8949 20.5195 23.0002 20.2652 23.0002 20C23.0002 19.7348 22.8949 19.4805 22.7074 19.293Z",
    fill: "url(#paint0_linear_507_2649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H20V20.586L21.293 19.293C21.4816 19.1108 21.7342 19.01 21.9964 19.0123C22.2586 19.0146 22.5094 19.1198 22.6948 19.3052C22.8802 19.4906 22.9854 19.7414 22.9877 20.0036C22.99 20.2658 22.8892 20.5184 22.707 20.707L19.707 23.707C19.5195 23.8945 19.2652 23.9998 19 23.9998C18.7348 23.9998 18.4805 23.8945 18.293 23.707L15.293 20.707C15.1108 20.5184 15.01 20.2658 15.0123 20.0036C15.0146 19.7414 15.1198 19.4906 15.3052 19.3052C15.4906 19.1198 15.7414 19.0146 16.0036 19.0123C16.2658 19.01 16.5184 19.1108 16.707 19.293L18 20.586V15H13C12.2046 15.0008 11.442 15.3171 10.8796 15.8796C10.3171 16.442 10.0008 17.2046 10 18V25C10.0008 25.7954 10.3171 26.558 10.8796 27.1204C11.442 27.6829 12.2046 27.9992 13 28H25C25.7954 27.9992 26.558 27.6829 27.1204 27.1204C27.6829 26.558 27.9992 25.7954 28 25V18C27.9992 17.2046 27.6829 16.442 27.1204 15.8796C26.558 15.3171 25.7954 15.0008 25 15Z",
    fill: "#E8EFF4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_507_2649",
    x1: 19,
    y1: 14.5,
    x2: 19,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/Collect.60ad6c277daf67a5d17b9441cdeb1091.svg";
export { ForwardRef as ReactComponent };